<div class="p-7 max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-2">{{dialogTitle}}</p>
  <p class="text-[13px] text-[var(--base-text-alt-dark)] m-0 mb-5">{{summary}}</p>

  <app-results-problem-list [problems]="data?.problems ?? []"
                            [problemsOmitted]="data?.problemsOmitted ?? 0"></app-results-problem-list>

  <div class="flex justify-end gap-3 mt-6">
    <!--
      Blocking shows one button and nothing else. There is no "do it anyway": the file
      was not stored, so there is nothing to proceed with.
    -->
    <button *ngIf="isBlocking" (click)="closeDialog(false)"
            class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Close</button>

    <button *ngIf="!isBlocking" (click)="closeDialog(false)"
            class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button *ngIf="!isBlocking" (click)="closeDialog(true)"
            class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">{{confirmText}}</button>
  </div>
</div>
